"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable quotes, quote-props, comma-dangle */

/**
 * This file is regenerated by generate-api-constants.js
 * Do not edit it manually.
 * Last generated Mon Dec 03 2018 09:43:56 GMT-0500 (EST)
 **/

var MSA_ALIAS_TO_ID = exports.MSA_ALIAS_TO_ID = {
  "new-york": 1,
  "los-angeles": 2,
  "san-francisco": 3,
  "chicago": 4,
  "miami": 5,
  "boston": 6,
  "washington-dc": 7,
  "seattle": 8,
  "atlanta": 9,
  "austin": 10,
  "charlotte": 11,
  "columbus": 12,
  "dallas": 13,
  "denver": 14,
  "houston": 15,
  "minneapolis": 16,
  "philadelphia": 17,
  "phoenix": 18,
  "portland": 19,
  "san-diego": 20,
  "las-vegas": 21,
  "raleigh": 22,
  "baltimore": 23,
  "tampa": 24,
  "st-louis": 25,
  "orlando": 26,
  "nashville": 27,
  "sacramento": 28,
  "kansas-city": 29,
  "cincinnati": 30,
  "detroit": 31,
  "pittsburgh": 32,
  "cleveland": 33,
  "milwaukee": 34,
  "london": 35,
  "toronto": 36,
  "vancouver": 37,
  "sydney": 38,
  "melbourne": 39,
  "brisbane": 40,
  "perth": 41,
  "adelaide": 42,
  "new-orleans": 43,
  "san-antonio": 44,
  "indianapolis": 45,
  "salt-lake-city": 46,
  "honolulu": 47,
  "calgary": 48,
  "inland-empire": 49,
  "missoula": 50,
  "manchester": 51,
  "bristol": 52,
  "birmingham": 53,
  "leeds": 54,
  "newcastle": 55,
  "glasgow": 56,
  "edinburgh": 57,
  "united-states": 58,
  "canada": 59,
  "united-kingdom": 60,
  "australia": 61,
  "singapore": 62,
  "hong-kong": 66,
  "united-arab-emirates": 67,
  "south-africa": 68,
  "new-zealand": 69,
  "netherlands": 72,
  "ireland": 73,
  "norway": 74,
  "sweden": 75,
  "thailand": 76,
  "germany": 77,
  "malaysia": 78
};